import { render, staticRenderFns } from "./SystematicIntimidationForm.vue?vue&type=template&id=b5c57ec2&scoped=true&"
import script from "./SystematicIntimidationForm.vue?vue&type=script&lang=js&"
export * from "./SystematicIntimidationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5c57ec2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/otavio.cardoso.neto/Workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b5c57ec2')) {
      api.createRecord('b5c57ec2', component.options)
    } else {
      api.reload('b5c57ec2', component.options)
    }
    module.hot.accept("./SystematicIntimidationForm.vue?vue&type=template&id=b5c57ec2&scoped=true&", function () {
      api.rerender('b5c57ec2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/intimidation-form/SystematicIntimidationForm.vue"
export default component.exports